export const fieldsToRemoveMap = {
  removeImageUrl: "imageUrl",
  removeHeroImageUrl: "heroImageUrl",
  removeThumbnailUrl: "thumbnailUrl",
  removeMediaUrl: "mediaUrl",
};
